import { PayloadAction } from '@reduxjs/toolkit';
import { Tracking } from '@services/analytics';
import {
  MoveInsideSelectionPayload,
  moveDownInsideSelection,
  moveUpInsideSelection,
} from '@store/selection/selection.action';
import { SetSelectedIdentity, setSelectedIdentity } from '@store/user/user.actions';
import { all, getContext, takeLatest } from 'redux-saga/effects';

function* trackGroupedDocumentReordered({ payload }: PayloadAction<MoveInsideSelectionPayload>) {
  const trackingService: Tracking = yield getContext('trackingService');
  trackingService.groupedDocumentReordered({ fhirReference: payload.id });
}

function* trackSelectedIdentityUpdated({ payload }: ReturnType<SetSelectedIdentity>) {
  const trackingService: Tracking = yield getContext('trackingService');

  trackingService.selectedIdentityUpdated({
    newSelectedIdentity: `${payload.identity.type}/${payload.identity.id}`,
  });
}

export function* trackingDocumentActionsSaga() {
  yield all([takeLatest(moveDownInsideSelection.type, trackGroupedDocumentReordered)]);
  yield all([takeLatest(moveUpInsideSelection.type, trackGroupedDocumentReordered)]);
  yield all([takeLatest(setSelectedIdentity.type, trackSelectedIdentityUpdated)]);
}
